import { TextField } from '@components/ui';
import { SearchOutlined } from '@icon';
import React, { useState } from 'react';
import { injectIntl } from 'react-intl';
import { SearchInputSC } from './search-input.styled';

type TProps = {
  isBlock?: boolean;
  intl: any;
  onSearch?(query: string): void;
};

const SearchInput: React.FC<TProps> = ({ intl, isBlock, onSearch }: TProps) => {
  const [query, setQuery] = useState('');

  const onChange = (e: any) => {
    const value = e.currentTarget.value;
    setQuery(e.currentTarget.value);
    if (value.length > 1) {
      onSearch?.(value);
    }
    if (value.length === 0) {
      onSearch?.('');
    }
  };

  return (
    <SearchInputSC isBlock={isBlock}>
      <TextField
        placeholder={intl.formatMessage({ id: 'placeholder.search' })}
        value={query}
        onChange={onChange}
        style={{ width: '100%' }}
        right={<TextField.Icon Icon={SearchOutlined} />}
      />
    </SearchInputSC>
  );
};

export default injectIntl(SearchInput);
